import Icon1 from "@assets/icons/Icon";
import { colors } from "sexy";

interface CustomDocumentProps {
  name: string;
  url: string;
  hidden?: boolean;
  indentLeft?: number;
  fontSize?: number;
  onClick?: () => void;
}

export const CustomDocument = ({
  name,
  url,
  hidden = false,
  indentLeft = 0,
  fontSize = 14,
  onClick,
}: CustomDocumentProps) => {
  function handleClick() {
    if (onClick) {
      onClick();
    } else {
      window.open(url, "_blank");
    }
  }

  return (
    <div
      className={`relative flex flex-row items-center gap-2 cursor-pointer hover:opacity-70 transition-opacity ${hidden ? "opacity-50" : ""}`}
      style={{
        marginLeft: `${indentLeft}px`,
        fontSize: `${fontSize}px`,
      }}
      onClick={handleClick}
    >
      <Icon1 name="file-text" size={20} color={colors.neutral_400} />
      {hidden && (
        <Icon1 name="invisible" size={16} color={colors.neutral_400} />
      )}
      <span
        className="text-neutral-400 underline flex-shrink truncate"
        style={{ fontSize: `${fontSize}px` }}
      >
        {name}
      </span>
    </div>
  );
};
